/**
 * Adresses de l'espace référencement, modale à onglets portée par l'URL de la page du blog
 * (`/marketing/publications/seo/<onglet>[/sujets]`). Source UNIQUE pour le front (ouverture,
 * onglets), la cible des notifications (cloche web, push mobile) et les liens d'e-mail du
 * backend : une adresse qui change se change ici.
 */

/** Page du blog, où vit la modale. */
export const BLOG_WEB_PATH = '/marketing/publications';

/** Premier segment de la modale sous la page du blog. */
export const SEO_SPACE_SEGMENT = 'seo';

export enum SeoSpaceTab {
  ARTICLES = 'articles',
  BACKLINKS = 'backlinks',
  SETTINGS = 'reglages',
}

export const SEO_SPACE_TABS: SeoSpaceTab[] = Object.values(SeoSpaceTab);

/** Troisième segment : la modale de choix des sujets du mois, ouverte sur l'onglet Articles. */
export const SEO_TOPICS_SEGMENT = 'sujets';

/**
 * Deuxième segment à la place d'un onglet : le parcours de première activation (auteur,
 * concurrents, sujets et jours), qui se termine par la première proposition de sujets.
 */
export const SEO_ONBOARDING_SEGMENT = 'bienvenue';

/** Onglet lu dans l'URL ; « Articles » quand le segment est absent ou inconnu (ancien `resultats` compris). */
export const seoSpaceTabFromSegment = (segment: string | undefined): SeoSpaceTab =>
  segment && (SEO_SPACE_TABS as string[]).includes(segment) ? (segment as SeoSpaceTab) : SeoSpaceTab.ARTICLES;

/**
 * Sous-chemin de modale (`seo/reglages`, `seo/articles/sujets`), à passer à `openPath` /
 * `replacePath` du hook de route modale.
 */
export const seoSpacePath = (tab: SeoSpaceTab, options?: { topics?: boolean }): string =>
  `${SEO_SPACE_SEGMENT}/${tab}${options?.topics ? `/${SEO_TOPICS_SEGMENT}` : ''}`;

/** Chemin web complet (sans locale) : cible des notifications et des liens d'e-mail. */
export const seoSpaceWebPath = (tab: SeoSpaceTab, options?: { topics?: boolean }): string =>
  `${BLOG_WEB_PATH}/${seoSpacePath(tab, options)}`;

/** Sous-chemin de modale du parcours de première activation (`seo/bienvenue`). */
export const seoSpaceOnboardingPath = (): string => `${SEO_SPACE_SEGMENT}/${SEO_ONBOARDING_SEGMENT}`;

/** Chemin web complet du parcours de première activation (lien d'e-mail, admin). */
export const seoSpaceOnboardingWebPath = (): string => `${BLOG_WEB_PATH}/${seoSpaceOnboardingPath()}`;

/** Paramètre de requête qui ouvre la relecture d'un article partenaire (mode B) sur l'onglet Backlinks. */
export const SEO_BACKLINK_REVIEW_PARAM = 'review';

/** Chemin web complet vers la relecture d'un lien (cible des notifications et des e-mails). */
export const seoBacklinkReviewWebPath = (seoBacklinkId: number): string =>
  `${seoSpaceWebPath(SeoSpaceTab.BACKLINKS)}?${SEO_BACKLINK_REVIEW_PARAM}=${seoBacklinkId}`;
